/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import {
  IsAssignedTaskFragmentDoc,
  IsOpenTaskFragmentDoc,
} from '../../../../alerts-common/src/lib/utils/alertConditions.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type UseDisplayedAlertsTask_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    status: Types.TaskNotificationStatus
    createdAt: string
    severity: Types.TaskNotificationSeverity
    pended: {
      __typename?: 'TaskStateChangeDetails'
      timestamp: string | null
    } | null
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type UseDisplayedAlertsTask_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_StopAccessibilityDownvotedByDrivers_Fragment =
  {
    __typename?: 'StopAccessibilityDownvotedByDrivers'
    id: string
    status: Types.TaskNotificationStatus
    createdAt: string
    severity: Types.TaskNotificationSeverity
    pended: {
      __typename?: 'TaskStateChangeDetails'
      timestamp: string | null
    } | null
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type UseDisplayedAlertsTask_StopActivationFailedNotification_Fragment = {
  __typename?: 'StopActivationFailedNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    id: string
    status: Types.TaskNotificationStatus
    createdAt: string
    severity: Types.TaskNotificationSeverity
    pended: {
      __typename?: 'TaskStateChangeDetails'
      timestamp: string | null
    } | null
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type UseDisplayedAlertsTask_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_TripPrebookingNoAssignment_Fragment = {
  __typename?: 'TripPrebookingNoAssignment'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_VehicleAvailabilityNotification_Fragment = {
  __typename?: 'VehicleAvailabilityNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_VehicleSurveillanceNotification_Fragment = {
  __typename?: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTask_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type UseDisplayedAlertsTaskFragment =
  | UseDisplayedAlertsTask_HubServiceNotification_Fragment
  | UseDisplayedAlertsTask_IvcTaskNotification_Fragment
  | UseDisplayedAlertsTask_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | UseDisplayedAlertsTask_PassengerUnbuckled_Fragment
  | UseDisplayedAlertsTask_RoadBlockageTaskNotification_Fragment
  | UseDisplayedAlertsTask_ShiftDeviationNotification_Fragment
  | UseDisplayedAlertsTask_StopAccessibilityDownvotedByDrivers_Fragment
  | UseDisplayedAlertsTask_StopActivationFailedNotification_Fragment
  | UseDisplayedAlertsTask_StopAreaMissingActiveStopsNotification_Fragment
  | UseDisplayedAlertsTask_StopDownVotedByDrivers_Fragment
  | UseDisplayedAlertsTask_StopPotentiallyUnreachable_Fragment
  | UseDisplayedAlertsTask_StopValidationFailed_Fragment
  | UseDisplayedAlertsTask_TimeManagementNotification_Fragment
  | UseDisplayedAlertsTask_TripPrebookingNoAssignment_Fragment
  | UseDisplayedAlertsTask_VehicleAvailabilityNotification_Fragment
  | UseDisplayedAlertsTask_VehicleIncidentNotification_Fragment
  | UseDisplayedAlertsTask_VehicleSurveillanceNotification_Fragment
  | UseDisplayedAlertsTask_VehicleWaypointAttendance_Fragment

export const UseDisplayedAlertsTaskFragmentDoc = gql`
    fragment UseDisplayedAlertsTask on TaskNotification {
  id
  status
  createdAt
  severity
  pended {
    timestamp
  }
  assigned {
    backofficeUserId
  }
  ...IsAssignedTask
  ...IsOpenTask
}
    ${IsAssignedTaskFragmentDoc}
${IsOpenTaskFragmentDoc}`
